import React from 'react';
import { useIntl } from 'react-intl';

import defaultMapLayer from '@/assets/map-layers/default-map-layer.png';
import satelliteMapLayer from '@/assets/map-layers/satellite-map-layer.png';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { MAPBOX_STYLES, MapboxStyle } from '@/services/types/map';

import { MapLayerButton } from './MapLayerButton';

const DESKTOP_LAYER_BUTTON_WIDTH = 84;
const MOBILE_LAYER_BUTTON_WIDTH = 156;

interface IProps {
  activeStyle: MapboxStyle;
  setMapboxStyle: (styleType: MapboxStyle) => void;
}

export const MapLayerButtons: React.FC<IProps> = ({ activeStyle, setMapboxStyle }) => {
  const intl = useIntl();
  const { isAboveXL } = useBreakpoint();
  const defaultImageAlt = intl.formatMessage({
    defaultMessage: 'Standard map layer image',
    id: 'hpEc+j',
  });
  const defaultButtonText = intl.formatMessage({ defaultMessage: 'Standard', id: 'cb2kY6' });
  const satelliteImageAlt = intl.formatMessage({
    defaultMessage: 'Satellite map layer image',
    id: 'JrK5cC',
  });
  const sateliteButtonText = intl.formatMessage({ defaultMessage: 'Satellite', id: 'RnYLTT' });

  return (
    <div className="flex flex-row gap-6">
      <MapLayerButton
        mapStyle={MAPBOX_STYLES.default}
        isActive={activeStyle === MAPBOX_STYLES.default}
        imageUrl={defaultMapLayer}
        imageAlt={defaultImageAlt}
        imageWidth={isAboveXL ? DESKTOP_LAYER_BUTTON_WIDTH : MOBILE_LAYER_BUTTON_WIDTH}
        buttonText={defaultButtonText}
        setMapboxStyle={setMapboxStyle}
      />
      <MapLayerButton
        mapStyle={MAPBOX_STYLES.satellite}
        isActive={activeStyle === MAPBOX_STYLES.satellite}
        imageUrl={satelliteMapLayer}
        imageAlt={satelliteImageAlt}
        imageWidth={isAboveXL ? DESKTOP_LAYER_BUTTON_WIDTH : MOBILE_LAYER_BUTTON_WIDTH}
        buttonText={sateliteButtonText}
        setMapboxStyle={setMapboxStyle}
      />
    </div>
  );
};
